import { createApi } from "@reduxjs/toolkit/query/react";
import { arnoldBaseQuery } from "../baseQuery";
import { CollectionResponse } from "../accounting/types";
import { Product } from "../accounting/product/types";
import { PartnerProductsParams } from "./types";

export const KNOWLEDGE_API_REDUCER_KEY = "knowledgeApi";

export const api = createApi({
    reducerPath: KNOWLEDGE_API_REDUCER_KEY,
    baseQuery: arnoldBaseQuery,
    endpoints: (build) => ({
        getSellerProducts: build.query<CollectionResponse<Product>, PartnerProductsParams>({
            query: ({ accountId, partnerId }) => ({
                url: `api/v1/knowledge/${accountId}/partner_products/purchase`,
                params: { partnerId },
            }),
        }),
        getBuyerProducts: build.query<CollectionResponse<Product>, PartnerProductsParams>({
            query: ({ accountId, partnerId }) => ({
                url: `api/v1/knowledge/${accountId}/partner_products/sales`,
                params: { partnerId },
            }),
        }),
    }),
});

export const { useGetSellerProductsQuery, useGetBuyerProductsQuery } = api;
